export default defineNuxtPlugin(() => {
  const colors = {
    random: () => {
      return '#' + Math.floor(Math.random() * 16777215).toString(16)
    }
  }
  return {
    provide: {
      colors
    }
  }
})
